import Vue from 'vue';
import uploadApkUrls from '../../../../urls/uploadApkUrls';

export const storePrefix = "upload_package_bundle_store";

const state = {
    sessionStorageKey: "upload_package_bundle",
    currentPackageBundle: {},
    currentPackageBundleIcon: {},
}

const getters = {
    currentPackageBundle(state) {
        return state.currentPackageBundle;
    },

    currentPackageBundleIcon(state) {
        return state.currentPackageBundleIcon;
    },
}

const mutations = {
    [`${storePrefix}setPackageBundle`](state, payload) {
        state.currentPackageBundle = payload;
    },

    [`${storePrefix}setPackageBundleIcon`](state, payload) {
        state.currentPackageBundleIcon = payload;
    },
}

const actions = {

    uploadCampaignApk(context, { file, fileName}) {
        return new Promise((resolve, reject) => {

            let formData = new FormData();

            formData.append("file", file);
            formData.append("fileName", fileName);

            Vue.$http.post(uploadApkUrls.uploadApk, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                body: formData
            });

           

        });
    },

    savePackageBundle(context, file) {
        return new Promise((resolve, reject) => {
            context.commit(`${storePrefix}setPackageBundle`, file);
            model.currentPackageBundle = file;
            model.currentCampaignObj.currentPackageBundle = file;
            setIsDirty();
            resolve();
        });

    },

    savePackageBundleIcon(context, file) {
        return new Promise((resolve, reject) => {
            context.commit(`${storePrefix}setPackageBundleIcon`, file);
            model.currentPackageBundleIcon = file;
            model.currentCampaignObj.currentPackageBundleIcon = file;
            resolve();
        });

    },

    clearPackageBundle(context) {
        return new Promise((resolve, reject) => {
            context.commit(`${storePrefix}setPackageBundle`, {});
            model.currentPackageBundle = {};
            model.currentCampaignObj.currentPackageBundle = {};
            resolve();
        });

    },

    clearPackageBundleIcon(context) {
        return new Promise((resolve, reject) => {
            context.commit(`${storePrefix}setPackageBundleIcon`, null);
            model.currentPackageBundleIcon = {};
            model.currentCampaignObj.currentPackageBundleIcon = {};
            resolve();
        });

    },
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/components/Common/UploadApk/store/uploadApk.js